const masterColumn = (renderJsonCell) => [
  {
    field: 'RigName_Number',
    headerName: 'Rig Name',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'question',
    headerName: 'Question',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'customerNames',
    headerName: 'Customers',
    width: 300,
    renderCell: renderJsonCell,
    editable: false,
    headerAlign: 'center',
    align: 'left',
    hide: false,
  },
  {
    field: 'referenceCategory',
    headerName: 'Search Category',
    width: 210,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false
  },
  {
    field: 'referenceCategoryTargetSpend',
    headerName: 'Target Spend',
    width: 210,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
    valueFormatter: (params) => `$${params.value}`
  },
  {
    field: 'referenceSpend',
    headerName: 'Search Spend',
    width: 210,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
    valueFormatter: (params) => `$${params?.value ?? 0}`
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false
  },
];

export { masterColumn };
